var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.ReviewCardAlert, {
        attrs: { rate: _vm.rate, "class-names": _setup.alertSpacingClass },
      }),
      _vm._v(" "),
      !_vm.rate.is_hidden_for_verification
        ? [
            !_vm.rate.is_deleted
              ? _c(_setup.ReviewCardResolved, { attrs: { rate: _vm.rate } })
              : _vm._e(),
            _vm._v(" "),
            _setup.showFullContent
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column",
                      class: _setup.isMobile ? "ga-4" : "ga-6",
                    },
                    [
                      !_vm.rate.is_refuted
                        ? _c(_setup.ReviewCardSupplements, {
                            attrs: { items: _setup.supplements },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(_setup.ReviewCardComments, {
                        attrs: {
                          sections: _setup.commentSections,
                          "show-watermark": !_setup.isMobile,
                          "limit-width": !_setup.isMobile,
                        },
                      }),
                      _vm._v(" "),
                      !_vm.rate.is_refuted
                        ? _c(_setup.ReviewCardImages, {
                            ref: "imagesRef",
                            attrs: { rate: _vm.rate },
                            on: { open: _setup.onOpenImage },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(_setup.ReviewCardDoctor, {
                        attrs: { rate: _vm.rate, lpu: _vm.lpu },
                      }),
                      _vm._v(" "),
                      _setup.showLpuReply
                        ? _c(_setup.ReviewCardReply, {
                            attrs: { rate: _vm.rate, type: "lpu" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _setup.showModeratorReply
                        ? _c(_setup.ReviewCardReply, {
                            attrs: { rate: _vm.rate, type: "moderator" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              : _setup.isPreview
              ? _c(
                  "div",
                  { class: { "mt-5": _setup.hasContentAboveTruncated } },
                  [
                    _setup.truncatedSupplement
                      ? _c(_setup.ReviewCardSupplements, {
                          attrs: {
                            items: [_setup.truncatedSupplement],
                            truncated: true,
                          },
                        })
                      : _setup.truncatedSection
                      ? _c(_setup.ReviewCardComments, {
                          attrs: {
                            sections: [_setup.truncatedSection],
                            truncated: true,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "text-body-2 primary--text mt-4 button-reset",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _setup.onReadMore.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_setup.tStatic("Читать полностью")) +
                            "\n      "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _setup.showFooter
              ? _c(_setup.ReviewCardFooter, {
                  class: {
                    "mt-4": _setup.isMobile,
                    "mt-6": !_setup.isMobile && _setup.showFullContent,
                  },
                  attrs: { rate: _vm.rate },
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_setup.isMobile && (_setup.showAdminLink || _setup.showPultLink)
        ? _c("div", { staticClass: "d-flex gc-4 mt-4" }, [
            _setup.showAdminLink
              ? _c(
                  "a",
                  {
                    staticClass: "adminka d-inline-flex px-4 py-1 ma-0",
                    attrs: {
                      href: _setup.adminHref,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [_vm._v("A")]
                )
              : _vm._e(),
            _vm._v(" "),
            _setup.showPultLink
              ? _c(
                  "a",
                  {
                    staticClass: "adminka d-inline-flex px-4 py-1 ma-0",
                    attrs: {
                      href: _setup.pultHref,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [_vm._v("pult")]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }